export default "__VITE_ASSET__Bv2cceWX__"